import { useEffect } from 'react'
import Amplify, { PubSub, Auth } from 'aws-amplify'
import { AWSIoTProvider } from '@aws-amplify/pubsub'
import { useSelector, useDispatch, batch } from 'react-redux'
import { useRouter } from 'next/router'

import awsConfig from 'src/aws-exports'
import { DEV } from '.config'
import useApi from 'utils/fetch'
import { setUser } from 'store/actions/user'
import makeId from 'utils/bson'
import { setTask } from 'store/actions/task'
// import useActiveTab from 'utils/activeTab'
Amplify.configure(awsConfig)

Amplify.addPluggable(new AWSIoTProvider({
  aws_pubsub_region: 'eu-west-2',
  aws_pubsub_endpoint: 'wss://a2znicngfvkjxe-ats.iot.eu-west-2.amazonaws.com/mqtt'
}))

export const getCognitoId = async () => {
  const credentials = await Auth.currentCredentials()
  // secretAccessKey
  // sessionToken
  // accessKeyId
  return credentials?.identityId
}

export function useSubscribe () {
  const router = useRouter()
  const user = useSelector((state) => state.user.value)
  const dispatch = useDispatch()
  const { API } = useApi()
  // const active = useActiveTab()

  const ACTION_MAP = {
    profileStatus: async () => {
      const { response } = await API({ userId: user?._id, tokenId: user?.tokenId })('getProfile')
      if (response) {
        batch(() => {
          dispatch(setUser({ ...user, ...response }))
          dispatch(setTask({
            [makeId()]: {
              type: 'api',
              data: {
                type: 'deleteRetained',
                id: user?._id,
                tokenId: user?.tokenId
              }
            }
          }))
        })
      }
    }
  }

  const subscribe = () => {
    try {
      if (user?._id) {
        return PubSub.subscribe(`personal/${user?._id}`).subscribe({
          next: async ({ value }) => {
            try {
              await ACTION_MAP[value.action]()
            } catch (e) {
            }
          },
          error: (e) => {
            console.error('subscribe #1', e)
            setTimeout(() => subscribe(), 1000 * 60) // every 60 s
          },
          complete: () => {}
        })
      }
    } catch (e) {
      console.error(`subscribe #2 ${e.message}`)
    }
  }

  useEffect(() => {
    if (!DEV) subscribe()
  }, [router?.pathname])
}

export const publish = async (topic, message) => {
  return await PubSub.publish(topic, message)
}

export async function signUp (email, API, dispatch) {
  try {
    await Auth.signUp({
      username: email,
      password: process.env.cognitoPassword,
      attributes: {
        email
      }
    })
  } catch (e) {
    const alreadyExists = e.message.includes('already exists')
    if (alreadyExists) await signInFlow(email, API, dispatch)
    else console.error('error signing up:', e.message)
  }
}

export async function signIn (email, API, dispatch) {
  try {
    await Auth.signIn(email, process.env.cognitoPassword)
  } catch (e) {
    const noUser = e.message.includes('does not')
    if (noUser) await signUpFlow(email, API, dispatch)
    else console.error('error signing in', e.message)
  }
}

export async function signOut () {
  try {
    await Auth.signOut()
  } catch (e) {
    console.error('error signing out: ', e.message)
  }
}

export const signUpFlow = async (email, API, dispatch) => {
  try {
    await signUp(email, API, dispatch)
    await signIn(email, API, dispatch)
    const cognitoId = await getCognitoId()
    if (cognitoId) {
      dispatch(setTask({
        [makeId()]: {
          type: 'api',
          data: {
            type: 'attachPolicy',
            cognitoId
          }
        }
      }))
    }
  } catch (e) {
    console.error('upflow', e)
  }
}

export const signInFlow = async (email, API, dispatch) => {
  try {
    await signIn(email, API, dispatch)
  } catch (e) {
    console.error('inflow', e)
  }
}
